module.exports = __webpack_public_path__ + "img/27.252b34bf.jpg";